import { useState } from "react";
import { X, Plus, ChevronLeft, ChevronRight } from "lucide-react";

// Editor taglie: chip ordinabili, aggiunta/rimozione/riordino manuale (nessun ordinamento automatico)
export const SizeChips = ({ value = [], onChange, testid = "size" }) => {
  const [input, setInput] = useState("");

  const add = () => {
    const v = input.trim();
    if (!v || value.includes(v)) { setInput(""); return; }
    onChange([...value, v]);
    setInput("");
  };
  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= value.length) return;
    const next = [...value];
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };

  return (
    <div>
      <div className="flex flex-wrap gap-1.5 mb-2" data-testid={`${testid}-chips`}>
        {value.length === 0 && <span className="text-xs text-slate-500">Nessuna taglia</span>}
        {value.map((t, i) => (
          <span key={t} data-testid={`${testid}-chip-${t}`} className="inline-flex items-center gap-1 bg-slate-800 border border-slate-700 rounded-lg pl-2 pr-1 py-1 text-sm text-slate-200">
            <button type="button" onClick={() => move(i, -1)} className="text-slate-500 hover:text-cyan-300"><ChevronLeft className="w-3 h-3" /></button>
            {t}
            <button type="button" onClick={() => move(i, 1)} className="text-slate-500 hover:text-cyan-300"><ChevronRight className="w-3 h-3" /></button>
            <button type="button" onClick={() => remove(i)} className="text-red-400 hover:text-red-300"><X className="w-3.5 h-3.5" /></button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input
          data-testid={`${testid}-input`}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
          placeholder="Aggiungi taglia (es. XL, 6, 0-3 mesi)"
          className="flex-1 bg-slate-900/60 border border-slate-700 rounded-lg px-3 py-1.5 text-sm text-slate-100 focus:outline-none focus:border-cyan-400/60"
        />
        <button type="button" data-testid={`${testid}-add`} onClick={add} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-cyan-500/15 text-cyan-300 border border-cyan-500/30 text-sm hover:bg-cyan-500/25">
          <Plus className="w-4 h-4" /> Aggiungi
        </button>
      </div>
    </div>
  );
};
